// LOCAL: per-store gate. `StoreProvider` (mounted above the app shell) owns the
// store fetch + recent-store tracking; this reads it from context to render the
// loading/error/404 states, then hands off to the section pages via `<Outlet />`.
// Each section page owns its own `<Page>` chrome (title + back) via `StorePage`.
import { Outlet } from 'react-router-dom';
import { PageStatus } from 'corso-admin-ui';
import { useActiveStore } from '~/providers/StoreProvider';
import { ErrorResponse } from '~/utils/errorResponse';

export default function StoreLayout() {
  const { storeId, store, isPending, isError, error } = useActiveStore();

  if (isError) {
    if (error instanceof ErrorResponse && error.response.status === 404) {
      return (
        <PageStatus
          icon="search"
          title="Store not found"
          detail={`We couldn't find a store with ID ${storeId}.`}
        />
      );
    }
    return <PageStatus.Error title="Couldn’t load store" error={error} />;
  }

  if (isPending || !store) return <PageStatus.Loading title="Loading store" />;

  return <Outlet />;
}
